import DOMPurify from 'dompurify';
import { BASE_RD_ICON_PREFIX } from './icon-constants';
export function getIconPathFromIconID(iconId) {
    return BASE_RD_ICON_PREFIX + iconId;
}
export async function appendSVGSprite(spritePath, isAbsolute = false) {
    if (!spritePath) {
        return;
    }
    // In case of a fetch mock, we don't want to
    // run this. As this will be the case in tests.
    if (typeof fetch === 'undefined' ||
        fetch.ponyfill ||
        fetch.Promise) {
        return;
    }
    if (spritePath.indexOf('http') === -1 && isAbsolute) {
        // eslint-disable-next-line no-param-reassign
        spritePath = `https://${spritePath}`;
    }
    const response = await fetch(spritePath);
    const text = await response.text();
    // eslint-disable-next-line no-unsanitized/method
    document.body.insertAdjacentHTML('afterbegin', DOMPurify.sanitize(`<div style="display: none;">${text}</div>`));
}
//# sourceMappingURL=icon-utils.js.map